module.exports = __webpack_public_path__ + "static/rph2rph-seller-tab-482e0c5e6c3196d819542b71ce4b9e79.png";